import styled from 'styled-components'
import media from 'styled-media-query'

export const Container = styled.div`
  position: relative;
  margin-bottom: 40px;
  padding: 10px 0;
`

export const SwiperContainer = styled.div`
  overflow: visible;
  padding: 10px 0;
`

export const Category = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 180px;
  background: ${({ actived }) => (actived ? 'linear-gradient(135deg, #0046a8 0%, #00a1ff 100%)' : '#fff')};
  border-radius: 16px;
  padding: 25px 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  z-index: 99;
  margin: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    width: 100px;
    height: 100px;
    background: ${({ actived }) => (actived ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 124, 255, 0.05)')};
    border-radius: 50%;
    bottom: -50px;
    right: -50px;
  }

  i {
    font-size: 56px;
    color: ${({ actived }) => (actived ? 'var(--white)' : '#0062cc')};
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }
  
  svg {
    font-size: 56px;
    color: ${({ actived }) => (actived ? 'var(--white)' : '#0062cc')};
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }
  
  &:hover i, 
  &:hover svg {
    transform: ${({ actived }) => (actived ? 'none' : 'scale(1.1)')};
  }
  
  ${media.lessThan('medium')`
    height: 150px;
    padding: 18px 15px;
    
    i, svg {
      font-size: 42px;
      margin-bottom: 10px;
    }
  `}
`

export const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ actived }) => (actived ? 'var(--white)' : '#4a5568')};
  text-align: center;
  transition: all 0.3s ease;
  
  ${media.lessThan('medium')`
    font-size: 14px;
  `}
`
